module.exports = __webpack_public_path__ + "img/empty.525d305c.png";